/**
 * Global @var prefix: `_`
 * Global @function prefix: `_`
 * Node prefix: `$`
 *
 * @var naming convention: snake_case
 * @function naming convention: camelCase
 * Node naming convention: camelCase
 */

//	========================================================================  //
//	Global vars
//	========================================================================  //

var _$window = $(window);
var _$document = $(document);
var _$html = $('html');
var _$body = $('body');
var _$htmlBody = $('html, body');
var _dpr = window.devicePixelRatio;

/**
 * App-specific variables.
 */

var _breakpoints = {
    's': 800,
    'm': 1008,
    'l': 1200
};

var _easings = {
    easeOutExpo: 'cubic-bezier(0.19, 1, 0.22, 1)'
};

var _flags = {
    scrollDisabled: 'has-scroll-disabled',
    styledSelects: false
};

var _$siteHeader = $('#js-site-header');
var _$logoBar = $('#js-logo-bar');
// var _$siteHeaderContent = $('#js-site-header-content');
// var _header_height = 0;

//	========================================================================  //
//	Responsive
//	========================================================================  //

var _window_width = 0;
var _window_height = 0;

/**
 * @function `_returnWindowWidth`
 *
 * A function to be used when in need of calculating
 * the width of the window.
 *
 * @return int
 */
function _returnWindowWidth() {
    return _$window.outerWidth();
}

/**
 * @function `_returnWindowHeight`
 *
 * A function to be used when in need of calculating
 * the height of the window.
 *
 * @return int
 */
function _returnWindowHeight() {
    return _$window.outerHeight();
}

/**
 * @function `_calcWindowDimensions`
 *
 * A function to be run when @var `_window_width`
 * should be updated.
 */
function _calcWindowDimensions() {
    _window_width = _returnWindowWidth();
    _window_height = _returnWindowHeight();
}
var _calcWindowDimensionsDebounced = _.debounce(_calcWindowDimensions, 200);

/**
 * @var `onResize`
 *
 * A collection of callbacks to be executed when
 * the window is resized.
 * `onResize.do` is the only function to be called when
 * the window is resized.
 */
var onResize = {
    callbacks: {},
    do: function() {
        // console.groupCollapsed('== onResize ==========');
        _calcWindowDimensions();
        var callbacks = onResize.callbacks;
        $.each(callbacks, function(i, callback) {
            callback();
        });
        // console.groupEnd();
    }
};
var onResizeDebounced = _.debounce(onResize.do, 200);

/**
 * The only resize event.
 */
_$window.on('resize', function() {
    onResizeDebounced();
});

//	========================================================================  //
//	On DOM ready
//	========================================================================  //

/**
 * @var `onReady`
 *
 * A collection of callbacks to be executed when
 * DOM is ready.
 * `onReady.do` is the only function to be called on
 * DOM ready.
 */
var onReady = {
    callbacks: {},
    do: function() {
        // console.groupCollapsed('== onReady ==========');
        _calcWindowDimensions();
        var callbacks = this.callbacks;
        $.each(callbacks, function(i, callback) {
            callback();
        });
        // console.groupEnd();
    }
};

/**
 * The only ready event.
 */
_$document.ready(function() {
    onReady.do();
});

//	========================================================================  //
//	Scroll
//	========================================================================  //

var _scroll_position = 0;
var _last_scroll = 0;
var _started_scroll_at = 0;
var _prev_scroll_direction = '';
var _scroll_direction = '';
var _scroll_direction_change = false;

/**
 * @function `_saveStartScrollPosition`
 *
 * Helper function to save scroll position whenever
 * user starts scrolling after a short pause. That
 * short pause is detected using debouncing through
 * function `_afterScrollDebounced`.
 */
function _saveStartScrollPosition() {
    if( _started_scroll_at === 0 ) {
        _started_scroll_at = _scroll_position;
    }
    // console.log(_started_scroll_at);
}

/**
 * @function `_disableHover`
 *
 * Avoid unnecessary paints through disabling hover
 * effects as the user scrolls.
 */
function _disableHover() {
    if( !_$body.hasClass(_flags.scrollDisabled) ) {
        _$body.addClass(_flags.scrollDisabled);
    }
}

/**
 * @function `_enableHover`
 */
function _enableHover() {
    if( _$body.hasClass(_flags.scrollDisabled) ) {
        _$body.removeClass(_flags.scrollDisabled);
    }
}

/**
 * @function `_resetStartScrollPosition`
 *
 * A function to reset the "started scrolling at"
 * position.
 */
function _resetStartScrollPosition() {
    _started_scroll_at = 0;
}

/**
 * @function `_afterScroll`
 *
 * A function to run multiple functions that need
 * to be run when user is done with scrolling.
 */
function _afterScroll() {
    _resetStartScrollPosition();
    _enableHover();
}
var _afterScrollDebounced = _.debounce(_afterScroll, 250);

/**
 * @function `_scrollingDown`
 *
 * A function that returns true if the user is
 * scrolling down, false if scrolling up.
 *
 * @return result | true or false
 */
function _scrollingDown() {
    var result;
    if( _scroll_position > _last_scroll ) {
        result = true;
    }
    else {
        result = false;
    }
    return result;
}

/**
 * @function `_updateLastScroll`
 *
 * A function that saves the current scroll position
 * to @var `_last_scroll`
 */
function _updateLastScroll() {
    _last_scroll = _scroll_position;
}

/**
 * @function `_detectScrollDirectionChange`
 *
 * A function that detects a change in the scroll direction.
 */
function _detectScrollDirectionChange() {
    if( _scroll_position === 0 ) {
        _scroll_direction = 'down';
        _prev_scroll_direction = 'down';
    }
    if( _scroll_position > _last_scroll ) {
        _scroll_direction = 'down';
    }
    if( _scroll_position < _last_scroll ) {
        _scroll_direction = 'up';
    }
    _scroll_direction_change = ( _scroll_direction !== _prev_scroll_direction ) ?
        true : false;
    // if( _scroll_direction_change ) {
    // 	console.log('direction change!');
    // }
}

/**
 * @function `_updateScrollDirection`
 *
 * A function that saves the current scroll direction
 * to @var `_prev_scroll_direction`
 */
function _updateScrollDirection() {
    _prev_scroll_direction = _scroll_direction;
}

/**
 * @var `onScroll`
 *
 * A collection of callbacks to be executed on scroll.
 * `onScroll.do` is the only function to be called on
 * scroll.
 *
 * 1. The collection of callbacks. This is the place
 *    where all additional callbacks are appended to
 *    one another.
 * 2. Always save start scroll position on start.
 *
 */
var onScroll = {
    callbacks: {}, /* [1] */
    do: function() {
        _saveStartScrollPosition(); /* [2] */
        _detectScrollDirectionChange();
        _disableHover();
        var callbacks = this.callbacks;
        $.each(callbacks, function(i, callback) {
            callback();
        });
        _updateLastScroll();
        _updateScrollDirection();
        _afterScrollDebounced();
    }
};

/**
 * @function `calcScrollPosition`
 *
 * A function that calculates the current scroll position
 * and saves it so that it's accessible to other
 * functions run on scroll.
 *
 * @var _scroll_position (global)
 */
onScroll.callbacks.calcScrollPosition = function() {
    _scroll_position = _$window.scrollTop();
};

/**
 * @function `watchScrollDirection`
 *
 * A function that checks for a change in the scroll direction.
 *
 * 1. If direction changes, reset the scroll position saved as "starting"
 *    scroll position.
 */
onScroll.callbacks.watchScrollDirection = function() {
    _detectScrollDirectionChange();
    if( _scroll_direction_change ) {
        _resetStartScrollPosition();
    }
};

// /**
//  * @function `resetStartScrollPositionIfRequired`
//  *
//  * Reset start scroll position if user
//  * scrolls down.
//  */
// onScroll.callbacks.resetStartScrollPositionIfRequired = function() {
// 	if( _scrollingDown() ) {
// 		_resetStartScrollPosition();
// 	}
// };

/**
 * The only scroll event.
 */
_$window.on('scroll', function() {
    onScroll.do();
});

//	========================================================================  //
//	Modals
//	========================================================================  //

var _before_paused_scroll = 0;
// var _modal = '#js-modal';
// var _$modal = $(_modal);
// var _doCloseModalBtn = '#js-close-modal';
// var _$closeModalBtn = $(_doCloseModalBtn);
// var _modalContent = '#js-modal-content';
// var _$modalContent = $(_modalContent);

/**
 * @function `_pauseScroll`
 *
 * 1. Retain scroll position when locking the viewport.
 *    Especially useful if pausing the scroll makes the
 *    entire view scroll back to top.
 * 2. Take note of which interaction paused the scroll.
 *
 * @param initiator (string)
 */
function _pauseScroll( initiator ) {
    var initiators_str = _$htmlBody.attr('data-initiator');
    initiators_str = ( initiators_str ) ? initiators_str+' '+initiator : initiator;
    _before_paused_scroll = _scroll_position; /* [1] */
    _$htmlBody.addClass('is-locked').attr('data-initiator', initiators_str); /* [2] */
    _$htmlBody.scrollTop( _before_paused_scroll ); /* [1] */
}
/**
 * @function `_resumeScroll`
 *
 * 1. Erase the note of which interaction paused the scroll.
 * 2. Reset the scroll position.
 *
 * @param initiator (string)
 */
function _resumeScroll( initiator ) {
    var initiators_str = _$htmlBody.attr('data-initiator');
    var initiatorsArr = initiators_str.split(' ');
    if( $.inArray( initiator, initiatorsArr) !== -1 ) {
        var newInitiators_str = initiators_str.replace(initiator, '');
        _$htmlBody.removeClass('is-locked').attr('data-initiator', newInitiators_str); /* [1] */
    }
    _$htmlBody.scrollTop( _before_paused_scroll ); /* [2] */
}

// /**
//  * @function `_setModalInitiatorId`
//  *
//  * Take note of which interaction made the modal visible.
//  *
//  * @param initiator (string)
//  */
// function _setModalInitiatorId( initiator ) {
// 	$('#js-modal').attr('data-initiator', initiator);
// }
//
// /**
//  * @function `_getModalAndAppendIt`
//  *
//  * Get modal HTML from another page and append it.
//  *
//  * @param url (string)
//  * @param initiator (string)
//  */
// function _getModalAndAppendIt( url, initiator ) {
// 	$.ajax({
// 		url: url,
// 		context: document.body
// 	}).done(function(html) {
// 		_$body.append(html);
// 		_setModalInitiatorId( initiator );
// 	});
// }
//
// /**
//  * @function `_showModal`
//  *
//  * A function that shows the relevant modal.
//  * Must be triggered by a link.
//  *
//  * @param link (string) | url
//  * @param initiator (string)
//  */
// function _showModal( link, initiator ) {
// 	_pauseScroll( initiator );
// 	_getModalAndAppendIt( link, initiator );
// }
//
// /**
//  * @function `_doCloseModal`
//  *
//  * A function that removes the current modal.
//  *
//  * @param $modal (node) | the modal to be removed.
//  * @param initiator (string)
//  */
// function _doCloseModal( $modal, initiator ) {
// 	$modal.remove();
// 	_resumeScroll( initiator );
// }
//
// /**
//  * @function `_closeModal`
//  *
//  * @param e (event)
//  */
// function _closeModal(e) {
// 	var target = e.target;
// 	var $target = $(target);
// 	var $modal;
// 	var modal_initiator = '';
// 	if( $target.closest(_doCloseModalBtn).length ) {
// 		var $button = $(this);
// 		$modal = $button.closest(_modal);
// 		modal_initiator = $modal.attr('data-initiator');
// 		_doCloseModal( $modal, modal_initiator );
// 	}
// 	else if( $target.closest(_modalContent).length ) {
// 		// console.log('Click on modal');
// 		return;
// 	}
// 	else {
// 		// console.log('Click on modal backdrop');
// 		$modal = $(this);
// 		modal_initiator = $modal.attr('data-initiator');
// 		_doCloseModal( $modal, modal_initiator );
// 	}
// }
//
// /**
//  * Global close
//  */
// _$document.on('click', _doCloseModalBtn+', '+_modal, function(e) {
// 	_closeModal(e);
// });

//	========================================================================  //
//	Mobile detection
//	========================================================================  //

/**
 *
 */
function isMobile() {
    return /android|ip(hone|od|ad)/i.test(navigator.userAgent);
}

//	========================================================================  //
//	Selects
//	========================================================================  //

/**
 * @function `_selectricCustomSelectedLi`
 *
 * This function wraps unwrapped text of clicked `li`
 * in a `span` with a selected class.
 *
 * @param $select (node) | the original select
 *
 * 1. By default, Selectric adds the selected class to
 *    the `li`, so that's our way to find the clicked `li`.
 * 2. Remove the active class from all text `span` created.
 * 3. Find all elements with the selected class and remove it.
 *    Amongst those, there is (and should only be) the
 *    clicked li. We don't want it to have the selected class
 *    but the text `span` created by this function.
 * 4. If a text `span` is found in the clicked `li`, flag it
 *    with the selected class.
 * 5. Otherwise...
 * 6. If the clicked `li` doesn't have any count `span` (e.g. an
 *    "all" option), then there is no need to separate the text
 *    string from the rest.
 * 7. Else, the `map` function will have returned an array. The
 *    text is stored in the first cell.
 * 8. The text is wrapped in a `span` and flagged as selected.
 */
function _selectricCustomSelectedLi( $select ) {

    var local = {
        classes: {
            selected: 'selected',
            textSpan: 'c-filter__text',
            countSpan: 'c-filter__count'
        }
    };

    var $selectricWrapper = $select.closest('.selectric-wrapper');
    var $createdTextSpan = $selectricWrapper.find('.'+local.classes.textSpan);
    var $clickedLi = $selectricWrapper.find('li.'+local.classes.selected); /* [1] */

    $createdTextSpan
        .removeClass(local.classes.selected); /* [2] */
    $selectricWrapper
        .find('.'+local.classes.selected)
        .removeClass(local.classes.selected); /* [3] */

    if( $clickedLi.find('.'+local.classes.textSpan).length ) {
        $clickedLi
            .find('.'+local.classes.textSpan)
            .addClass(local.classes.selected); /* [4] */
    }
    else { /* [5] */
        var targeted_text = '';
        var $clickedLiCountSpan = $clickedLi.find('.'+local.classes.countSpan);
        var text_array = $clickedLiCountSpan.map(function() {
            return this.previousSibling.nodeValue;
        });
        var no_count = ( text_array.length === 0 ) ? true : false;
        if( no_count ) {
            targeted_text = $clickedLi.text(); /* [6] */
        }
        else {
            targeted_text = text_array[0]; /* [7] */
        }
        $clickedLi.html(function(i, html) {
            return html.replace(targeted_text, '<span class="'+local.classes.textSpan+' '+local.classes.selected+'">'+$.trim(targeted_text)+'</span> ');
            /* [8] */
        });
    }

}

/**
 * @function `_styleSelects`
 *
 * Initialize Selectric plugin to style selects.
 *
 * @param $select (node) | the select(s) to style
 */
function _styleSelects( $select ) {
    $select.selectric({
        expandToItemText: true,
        arrowButtonMarkup: '',
        disableOnMobile: true,
        preventWindowScroll: false,
        maxHeight: 312,
        // onInit: function() {
        //     _flags.styledSelects = true;
        //     _selectricCustomSelectedLi( $(this) );
        // },
        // onChange: function() {
        //     if ( !_flags.styledSelects ) {
        //         return;
        //     }
        //     _selectricCustomSelectedLi( $(this) );
        //     // TODO: Ajax request to get the content.
        // }
    });
}

/**
 * @function `_resizeSelects`
 *
 * Using the resize-select plugin, resize
 * passed selects to match the width of the
 * selected option.
 *
 * @param $select (node) | the select(s) to resize
 * @param options (obj) | options for the plugin
 */
function _resizeSelects( $select, options ) {
    if( typeof options === 'undefined' || options === null ) {
        options = {};
    }
    $select.resizeSelect(options);
}

//	======================================================================  //
//	AJAX helpers
//	======================================================================  //

var _ajaxParams = {
    formsWithFeedback: '.js-shows-feedback',
    submitBtn: '.js-shows-feedback__action',
    dataAttrEnabledLabel: 'enabled-label',
    dataAttrProcessingLabel: 'processing-label',
    processingClass: 'is-processing'
};

var _formParams = {
    disabledSubmitClass: 'c-button--disabled'
};

/**
 * @function `_disableSubmit`
 *
 * Disables the submit button and styles it accordingly.
 *
 * @param $action (node) - the element to change.
 */
function _disableSubmit( $action ) {
    $action.addClass(_formParams.disabledSubmitClass)
        .attr('disabled', 'disabled');
}

/**
 * @function `_disableSubmit`
 *
 * Enables the submit button and styles it accordingly.
 *
 * @param $action (node) - the element to change.
 */
function _enableSubmit( $action ) {
    $action.removeClass(_formParams.disabledSubmitClass)
        .removeAttr('disabled');
}

/**
 * @function `_processingFeedback`
 *
 * Shows feedback to the UI that the action is processing.
 *
 * @param $action (node) - the element to change.
 */
function _processingFeedback( $action ) {
    var originalLabel = $action.data(_ajaxParams.dataAttrEnabledLabel) ?
        $action.data(_ajaxParams.dataAttrEnabledLabel) : $action.html();
    var processingLabel = $action.data(_ajaxParams.dataAttrProcessingLabel) ?
        $action.data(_ajaxParams.dataAttrProcessingLabel) : originalLabel;
    $action.html(processingLabel).addClass(_ajaxParams.processingClass);
    _disableSubmit( $action );
    return;
}

/**
 * @function `_stopProcessing`
 *
 * Resets the submit button to its default state.
 *
 * @param $action (node) - the element to change.
 */
function _stopProcessing( $action ) {
    var originalLabel = $action.data(_ajaxParams.dataAttrEnabledLabel) ?
        $action.data(_ajaxParams.dataAttrEnabledLabel) : $action.html();
    $action.html(originalLabel).removeClass(_ajaxParams.processingClass);
    _enableSubmit( $action );
    return;
}

_$document.on('submit', _ajaxParams.formsWithFeedback, function() {
    _processingFeedback( $(this).find(_ajaxParams.submitBtn) );
    return;
});

//	======================================================================  //
//	SVG
//	======================================================================  //

/**
 * @function `initSVGSupportForEverybody`
 *
 * Initializes the `svg4everybody` polyfill.
 */
function initSVGSupportForEverybody() {
    svg4everybody();
}

onReady.callbacks.svgSupport = initSVGSupportForEverybody;

//	======================================================================  //
//	Anchors (animated scroll)
//	======================================================================  //

var _anchorParams = {
    anchors: '.js-anchor',
    offset: 80,
    pixelsPerSecond: 5000
};

/**
 * @function `_scrollTo`
 *
 * Scrolls to the target (identified DOM element) of the clicked anchor tag.
 *
 * @param $clickedLink (node) - the clicked anchor tag
 * @param e (event) - the click event
 *
 * 1. Return the absolute result of the substraction as it might be negative
 *    if target is above the anchor.
 * 2. x1000 as the duration has to be defined in milliseconds.
 */
function _scrollTo( $clickedLink, e ) {
    var target = $clickedLink.attr('href');
    var $target = $(target);

    var currentScrollPos = _$window.scrollTop();
    var targetScrollPos = $target.offset().top - _anchorParams.offset;
    var distance = Math.abs(targetScrollPos - currentScrollPos); /* [1] */
    var duration = distance / _anchorParams.pixelsPerSecond * 1000; /* [2] */

    e.preventDefault();
    _$htmlBody.animate({
        scrollTop: targetScrollPos
    }, duration, 'linear');
}

_$document.on('click', _anchorParams.anchors, function(e) {
    _scrollTo( $(this), e );
});

/* Add to Cart datalayer */
var addToCartBtn = $('#js-add-to-cart');
if (typeof dataLayer !== 'undefined' && addToCartBtn.length) {
    addToCartBtn.on('click', function () {
        var productFormVariant = $('#js-product-form [name="color"]:checked');
        var data = JSON.parse(JSON.parse(addToCartBtn.data('datalayerClick')));
        data.quantity = 1;
        if (productFormVariant.length) {
            data.variant = productFormVariant.val();
        }
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            'event': 'addToCart',
            'ecommerce': {
                'currencyCode': 'EUR',
                'add': {
                    'products': [data]
                }
            }
        });
    });
}

// ====================================================================== //
// Custom Events
// ====================================================================== //

function customEventPolyfill () {
    if (typeof window.CustomEvent === 'function') return false;

    function CustomEvent (event, params) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
}

customEventPolyfill();
